import { endOfDay, isPast } from "date-fns";
import { sortDate } from "../../utils.js";
import { includesTimeOfDay } from "./includesTimeOfDay.js";
export const getRenewalDispatches = (dispatches) => {
    const sortedDispatches = dispatches
        .filter(({ distributionDate }) => !!distributionDate)
        .sort(({ distributionDate: a }, { distributionDate: b }) => sortDate(a, b));
    const currentDispatchIndex = sortedDispatches.findIndex((dispatch) => {
        if (!dispatch.distributionDate)
            return false;
        // If dispatch date has time component (e.g., book club), use exact time.
        // Otherwise (e.g., book subscription), use end of day for backward compatibility.
        const dispatchDate = includesTimeOfDay(dispatch.distributionDate)
            ? new Date(dispatch.distributionDate)
            : endOfDay(new Date(dispatch.distributionDate));
        return !isPast(dispatchDate);
    });
    if (currentDispatchIndex === -1) {
        return { prev: null, current: null, next: null, index: -1 };
    }
    return {
        prev: currentDispatchIndex > 0
            ? sortedDispatches[currentDispatchIndex - 1]
            : null,
        current: sortedDispatches[currentDispatchIndex],
        next: currentDispatchIndex + 1 < sortedDispatches.length
            ? sortedDispatches[currentDispatchIndex + 1]
            : null,
        index: currentDispatchIndex,
    };
};
